module.exports = __webpack_public_path__ + "media/icons/check-off@3x-2eb29603.svg";